import { render, staticRenderFns } from "./ketepatan_pekerjaan.vue?vue&type=template&id=5850c866"
import script from "./ketepatan_pekerjaan.vue?vue&type=script&lang=js"
export * from "./ketepatan_pekerjaan.vue?vue&type=script&lang=js"
import style0 from "./ketepatan_pekerjaan.vue?vue&type=style&index=0&id=5850c866&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports